import { reactive, onBeforeMount, onMounted, onBeforeUnmount,computed,watch } from 'vue'
import { getPakSize } from '@/service'
import { $enum } from '@/global'
import { useStore } from 'vuex'
import {createTraining, saveTrainingExData} from '@/service'
import {getWindDirection} from '@/utils/index'

interface ISettlementData{
    evaluateData:any;           //偏差信息
    fileData:any;               //电子桩图片文件
    trainingId?: string;        //训练id
}

/**
 * @description 加载3D模型动画
 * @param stationdId 站所id
 * @returns
 */
export default function useLoading3D(
    stationdId: string | number | null,
    resourceFileList: any[],
    proxy?: any,
    otherParams?: any
) {
    const store = useStore();
    const state = reactive({
        progressValue: 0,
        pakSizeList: [] as any, // 模型文件大小
        loadingStatus: {},
        receive: 0 as number | string, //接收的总大小
        lastReceive: 0 as number | string,
        lastReceiveTime:null as any,
        sum: 0 as number | string, // 文件总大小
        speed: 0 as number | string, // 速度,
        currentFile: 1 as number | string,
        maxFile: 0 as number | string,

        isShowLoading: false,
        extraPakSizeMap:{} as any,
        currentExtraId: null as any,
    })

    const engineInitialized = computed(() => store.state.viewData.engineInitialized);

    if(store.state.persistence.currentUavInfo.trainingId || store.state.persistence.towerIdentify.sceneInfo){
        //store.state.persistence.towerIdentify.sceneInfo 有内容表示在设备认识页面中调用
        if(!store.state.viewData.enterScene){
            showOrHideEngineView(true)
            store.commit("viewData/setEnterScene", true);
        }
    }else{
        if(store.state.persistence.userInfo?.userId && store.state.persistence.currentUavInfo?.uavId && store.state.persistence.currentUavInfo.sceneInfo?.id){
            createTrainInfo()
        }
    }

    function showOrHideEngineView(status: boolean): void {
        if (status) {
            store.commit('viewData/setIshowEngineView', true)
        } else {
            store.commit('viewData/setIshowEngineView', false)
        }
    }

    ///////////////////////////////////////////////////////  方法
    function setLoadingStatus(data: any): void {
        // console.log("debugger setLoadingStatus",data)
        if (data.id !== stationdId && data.id !== state.currentExtraId) {
            state.receive = 0;
            state.lastReceive = 0;
            state.lastReceiveTime = 0;
            state.sum = 0;
            state.progressValue = 0;
            state.currentExtraId = data.id;
            state.currentFile = Number(state.currentFile) + 1;
            state.pakSizeList = state.extraPakSizeMap[data.id];
        }
        state.loadingStatus = data.progressData;

        let sum = 0;
        let receive = 0;
        if (data.progressData.totalSize != null && data.progressData.totalReceived != null) {
            sum = data.progressData.totalSize;
            receive = data.progressData.totalReceived;
        } else {
            const loadingStatusList: any[] = Object.values(state.loadingStatus);

            for (const pakFile of state.pakSizeList) {
                const fileName = pakFile.fileName;
                const fileSize = Number(pakFile.size) || 0;

                const loadingStatus: any = loadingStatusList.find(
                    (item: any) => item.pakName?.includes(fileName)
                );

                const receivedSize = Number(loadingStatus?.receivedLength) || 0;

                sum += fileSize;
                receive += receivedSize;
            }
        }

        if (sum) {
            const unit = 1024
            if (receive > sum) { //收到的资源大小不能大于总大小
                receive = sum
            }
            const receiveTime = Date.now();
            state.receive = (receive / (unit * unit)).toFixed(2) + 'M'
            state.sum = checkSizeOverGorM(sum)
            state.speed = getSpeed(receive, state.lastReceive,receiveTime,state.lastReceiveTime)

            const per = Math.floor(receive / sum * 100)
            // console.log('per--', per)
            state.progressValue = per > 100 ? 100 : per

            if (state.progressValue == 100) {
                showOrHideEngineView(true)
                setTimeout(() => {
                    state.isShowLoading = false;
                }, 1000)
            }
        } else {
            state.progressValue = 0
        }
    }

    function checkSizeOverGorM(value: number): number | string {
        const unit = 1024
        let isOverG = value / (unit * unit * unit) > 1 ? value / (unit * unit * unit) : false
        if (isOverG) {
            return isOverG.toFixed(2) + "G"
        } else {
            return (value / (unit * unit)).toFixed(2) + "M"
        }
    }

    function getSpeed(receive: any, lastReceive: any, receiveTime: any, lastReceiveTime: any) {
        if (!state.lastReceive)
        {
            state.lastReceive = receive;
            state.lastReceiveTime = receiveTime - 200;//保证初始速度
        }
        if (lastReceive <= 0 || (receiveTime - lastReceiveTime <= 200))
        {
            return state.speed || '0.00b/s'
        }
        const time = (receiveTime - lastReceiveTime) / 1000;
        let speed = (receive - lastReceive) / time;
        const unit = 1024
        const speedOverM = speed / (unit * unit) > 1 ? speed / (unit * unit) : false
        const speedOverKB = speed/ unit > 1 ? speed / unit : false

        state.lastReceive = receive;
        state.lastReceiveTime =receiveTime;
        if (speedOverM) {
            return speedOverM.toFixed(0) + "M/s"
        } else if (speedOverKB) {
            return speedOverKB.toFixed(0) + "kb/s"
        } else {
            return speed.toFixed(0) + 'b/s'
        }
    }

    function handleOpenPDF(){
        try {
            const link = document.createElement('a');
            link.href = '/ppt/frameRate.pdf';
            link.target = '_blank';
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            // console.error('无法打开PDF文件:', error);
        }
    }

    //生成训练数据
    async function createTrainInfo(){
        let windPower:any = null
        let windDirection:any = null
        if((store.state.persistence.currentUavInfo.sceneInfo?.courseTypeId == $enum.CourseTypeEnum.CAAC多旋翼 && store.state.persistence.currentUavInfo.sceneInfo?.sceneCategoryId == $enum.SceneCategoryEnum.科目训练)
            || (store.state.persistence.currentUavInfo.sceneInfo?.courseTypeId == $enum.CourseTypeEnum.电力巡检 &&
            (store.state.persistence.currentUavInfo.sceneInfo?.sceneCategoryId == $enum.SceneCategoryEnum.模拟考核 ||store.state.persistence.currentUavInfo.sceneInfo?.sceneCategoryId == $enum.SceneCategoryEnum.科目训练))){
            //caac训练和输电训练模式创建训练数据加风速
            windPower = store.state.persistence.userTrainSettingInfo.windPower
        }
        if(store.state.persistence.currentUavInfo.sceneInfo?.courseTypeId == $enum.CourseTypeEnum.CAAC多旋翼){
            //caac训练和考核模式加风向
            if(store.state.persistence.currentUavInfo.sceneInfo?.sceneCategoryId == $enum.SceneCategoryEnum.科目训练){
                windDirection = store.state.persistence.userTrainSettingInfo.windDirection
            }
            if(store.state.persistence.currentUavInfo.sceneInfo?.courseTypeId == $enum.CourseTypeEnum.CAAC多旋翼 && store.state.persistence.currentUavInfo.sceneInfo?.sceneCategoryId == $enum.SceneCategoryEnum.模拟考核){
                windDirection = getWindDirection(store.state.persistence.examWindDirection)
            }
        }
        if(store.state.persistence.currentUavInfo.sceneInfo?.courseTypeId == $enum.CourseTypeEnum.电力巡检 && (store.state.persistence.currentUavInfo.sceneInfo?.sceneCategoryId == $enum.SceneCategoryEnum.模拟考核 ||store.state.persistence.currentUavInfo.sceneInfo?.sceneCategoryId == $enum.SceneCategoryEnum.科目训练)){
            windDirection = store.state.persistence.userTrainSettingInfo.windDirection
        }
        let params = {
            userId:store.state.persistence.userInfo.userId,
            sceneId:store.state.persistence.currentUavInfo.sceneInfo?.id,
            uavSpecificationId:store.state.persistence.currentUavInfo.uavId,
            airLineId:otherParams?.airLineId,
            difficultyType:otherParams?.difficultyType,
            windPower:windPower,
            windDirection:windDirection,
            stationId:stationdId,
        }
        const res = await createTraining(params);
        if(res.code != $enum.EnumResult.SUCCESS){
            proxy?.vknMessage.error('生成训练数据失败！')
            return
        }
        const trainData = res.data;
        const {trainingId} = trainData as any || {};
        store.commit('persistence/setCurrentUavInfo', {
            ...store.state.persistence.currentUavInfo,
            trainingId: trainingId
        });
        showOrHideEngineView(true)
        store.commit("viewData/setEnterScene", true);
    }

    // Base64 转 Blob
    function base64ToBlob(base64Data:any) {
        const arr = base64Data.split(',');
        const mime = arr[0].match(/:(.*?);/)[1];
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new Blob([u8arr], { type: mime });
    }

    // Base64 转 File（文件名用当前时间戳）
    function base64ToFile(base64Data:any) {
        const blob = base64ToBlob(base64Data);
        const ext = blob.type.split('/')[1];
        const timestamp = Date.now();
        return new File([blob], `${timestamp}.${ext}`, { type: blob.type });
    }

    //存储结算数据
    /**
     * @param settlementData    结算数据
     */
    async function storeSettlementData(settlementData:ISettlementData){
        const {fileData, trainingId} = settlementData || {};
        let imgFile = base64ToFile(fileData);
        let param = new FormData();
        param.append("imageFile", imgFile);
        // @ts-ignore
        param.append("trainingId", trainingId);
         // @ts-ignore
        await saveTrainingExData(param, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        });
    }

    function setExtraFileMap(extraFileMap: any) {
        if (extraFileMap) {
            state.extraPakSizeMap = extraFileMap;
            state.currentFile = 1;
            state.maxFile = 1 + Object.keys(state.extraPakSizeMap).length;
            // console.log("debugger",state.maxFile)
            // console.log("debugger",extraFileMap)
        }
    }
    ///////////////////////////////////////////////////////  生命周期
    onBeforeMount(() => {
        state.pakSizeList = resourceFileList;
    })

    onMounted(() => {

    })

    onBeforeUnmount(() => {
    })

    return {
        loadingState: state,
        setLoadingStatus,
        engineInitialized,
        handleOpenPDF,
        storeSettlementData,
        setExtraFileMap,
        showOrHideEngineView,
    }
}
